import { api } from "./api";

const actions = {
	deleteTheme: (code, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "DELETE",
					url: `/faiq/api/v3/theme/${code}`,
					onSuccess,
					onFailure
				})
			);
		};
	},
	getTreeTheme: (code, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/faiq/api/v3/theme/tree/${code}`,
					onSuccess,
					onFailure
				})
			);
		};
	},
	insertTreeFromJSON: (data, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v3/theme/json`,
					data,
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Train questions */
	startQuestionsTraining: (
		language,
		questionsToTranslate,
		questionsToTrain,
		theme,
		answerItem,
		onSuccess,
		onFailure = () => {}
	) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v3/theme/questions/train`,
					data: {
						language,
						questionsToTranslate,
						questionsToTrain,
						theme,
						answerItem
					},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Untrain questions */
	startQuestionsUntraining: (codes, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v3/theme/questions/untrain`,
					data: {
						codes
					},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Train all questions from a category */
	startCategoryTraining: ({ codes, type, messageID }, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v3/theme/category/train`,
					data: {
						codes,
						type,
						messageID
					},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Untrain all questions from a category */
	startCategoryUntraining: (codes, type, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v3/theme/category/untrain`,
					data: {
						codes,
						type
					},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Generate answer */
	generateAnswers: (
		codes = [],
		languages = [],
		saveInDatabase = true,
		onSuccess,
		onFailure = () => {}
	) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v3/theme/generate/answers`,
					data: {
						codes,
						languages,
						saveInDatabase
					},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Generate batch theme answers */
	generateAnswerBatch: (dataset, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v3/theme/generate/answers/batch`,
					data: {
						dataset
					},
					onSuccess,
					onFailure
				})
			);
		};
	}
};

export default actions;
